import StompChatService from "./StompChatService";
import { postMessage, debugLog } from "../Utils/utils";

let _sdkSubscription = null;
let _sdkEnabled = false;
// Who is shopping, as last worked out. The panel knows this the moment it
// restores a saved guest, which can be before the SDK has said hello — and a
// visitor is identified once, so a dropped announcement is never repeated and
// everything the card reports that visit is filed against nobody. Remembered
// here, and said again as soon as there is anyone listening.
let _lastUserPayload = null;

export function isSdkMode() { return _sdkEnabled; }

export function enableSdkBridge() {
  _sdkEnabled = true;
  if (_lastUserPayload) postMessage({ type: "sdk-user-update", payload: _lastUserPayload });
}

export function subscribeSdkActions(orgId) {
  if (!_sdkEnabled || !orgId) return;
  if (_sdkSubscription) return;

  if (!StompChatService.isConnected()) {
    StompChatService.onReconnect(() => { _subscribeTopic(orgId); });
    return;
  }
  _subscribeTopic(orgId);
}

function _subscribeTopic(orgId) {
  if (_sdkSubscription || !StompChatService.client || !StompChatService.connected) return;
  try {
    _sdkSubscription = StompChatService.client.subscribe(
      `/topic/org/${orgId}/sdk-action`,
      (msg) => {
        try {
          const payload = JSON.parse(msg.body);
          postMessage({ type: "sdk-action", payload: payload });
        } catch (e) {
          debugLog("[SdkBridge] Failed to parse sdk-action:", e);
        }
      }
    );
  } catch (e) {
    debugLog("[SdkBridge] Failed to subscribe to sdk-action topic:", e);
  }
}

export function notifySdkMessage(messagePayload) {
  if (!_sdkEnabled) return;
  postMessage({
    type: "sdk-message",
    payload: {
      content: messagePayload.content,
      senderId: messagePayload.senderId,
      senderName: messagePayload.senderName,
      timestamp: messagePayload.timestamp || Date.now(),
    },
  });
}

export function notifySdkUserUpdate(user) {
  // Only send userId and loggedIn status — no PII (email/name) to parent frame
  const payload = user
    ? { userId: user.id, loggedIn: true, isGuest: !!user.isGuest }
    : { loggedIn: false };
  // Kept whether or not anyone is listening yet; see _lastUserPayload.
  _lastUserPayload = payload;
  if (!_sdkEnabled) return;
  postMessage({ type: "sdk-user-update", payload });
}

export function unsubscribeSdkActions() {
  if (_sdkSubscription) {
    try { _sdkSubscription.unsubscribe(); } catch (e) {}
    _sdkSubscription = null;
  }
}
